<template>
	<el-upload v-loading="loading" class="logo-uploader" :class="{ 'logo-uploader--small': small }" :action="$store.getters.uploadURL" :show-file-list="false" :data="uploadData" :before-upload="beforeUpload" :on-success="onSuccess">
		<img v-if="imageURL" class="logo-uploader__image" :src="imageURL">
		<i v-else class="el-icon-plus logo-uploader__icon"></i>
		<ion-icon v-if="imageURL" name="close-circle" class="logo-uploader__delete-button" @click.stop="deleteImage"></ion-icon>
	</el-upload>
</template>

<script>
	
	export default {
		
		props: {
			small: { default: true },
			url: { default: "" },
			client: { default: 0 },
			project: { default: 0 },
		},
		
		methods: {
			
			deleteImage() {
				
				this.axios.delete("/image", {
					params: {
						client: this.client ? this.client : null,
						project: this.project ? this.project : null,
						imageURL: this.imageURL,
					}
				}).then((r) => {
					this.imageURL = "";
				}).catch(() => {
					
				});
				
			},
			
			beforeUpload(file) {
				
				this.loading = true;
				
				if (this.client) {
					this.uploadData.client = this.client;
				}
				
				if (this.project) {
					this.uploadData.project = this.project;
				}
				
			},
			
			onSuccess(r, file, fileList) {
				if (r.success) {
					setTimeout(() => {
						this.loading = false;
						this.imageURL = r.image_url;
					}, 1000);
				}
			},
			
		},
		
		watch: {
			url() {
				this.imageURL = this.url;
			},
		},
		
		data() {
			return {
				loading: false,
				uploadData: {},
				imageURL: this.url,
			}
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/ImageUploader.vue